import { gql } from 'src/generated/gql';
import { Flow, PatientTasksQuery } from 'src/generated/gql/graphql';
import { ChartElement } from 'src/nightingale/types/types';

export const GET_TASKS = gql(`
  query PatientTasks($patientId: ID!) {
    tasks(patientId: $patientId) {
      createdAt
      completedAt
      expiresAt
      flow {
        label
        name
        elements
      }
      taskId
    }
  }
`);

type TaskFlow = {
  label: Flow['label'];
  name: Flow['name'];
  elements: ChartElement[];
};

export type PatientTask = Omit<PatientTasksQuery['tasks'][number], 'flow'> & { flow: TaskFlow };
